import React, { ReactNode } from 'react';

import InputMaskLib, { Props } from 'react-input-mask';

type InputMaskProps = Omit<Props, 'children'> & {
  children?: JSX.Element;
};

export const InputMask: React.FC<InputMaskProps> = ({ children, ...props }) => {
  const child = () => children as unknown as ReactNode;

  return <InputMaskLib {...props} children={child} />;
};
